import axios from 'axios';
import moment from 'moment';
import React, { useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';

const CycleDatesModal = ({ show, setShow, dateArray, initialCycleDate, daysSupplied, selectedFacility }) => {
    const [selectedIndex, setSelectedIndex] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const { paramsFacilityId } = useParams();
    const [loading, setLoading] = useState(false);

    const printPage = async () => {
        let tokenStr = localStorage.getItem("accessToken");
        const payload = {
            "delivery_date": initialCycleDate,
            "delivery_period": daysSupplied,
            "facility_id": selectedFacility
        }
        try {
            setLoading(true);
            const data = await axios.post(`${process.env.REACT_APP_SERVER_URL}/reports/delivery-calendar`, payload, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            if (data?.data?.status == false) {
                toast.error(data.data.message);
            }
            else {
                toast.success("Calendar Generated Successfully");
                const { blobUrl } = await createIframeReportBlobUrl(data.data);
                setIframeSrc(blobUrl);
            }
        } catch (e) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    }
    return (
        <Modal show={show} onHide={() => {setShow(false)}} centered size="lg">
            <div style={{
                height: 0,
                overflow: 'hidden',
                width: 0
            }}>
                {iframeSrc && (
                    <iframe
                        src={iframeSrc}
                        style={{ width: "2000px", height: "500px", border: "none" }}
                        title="Preview Content"
                    />
                )}
            </div>
            <Modal.Header closeButton className="align-items-center">
                <Modal.Title className="fs-7 fw-semibold">Next Cycle Start Date</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex flex-wrap gap-3 justify-content-center">
                    {dateArray.map((dateStr, index) => {
                        const dateObj = moment(dateStr);
                        return (
                            <div
                                key={index}
                                className="date-card d-flex flex-column align-items-center justify-content-center p-3 rounded-4 shadow-sm"
                                style={{
                                    width: '100px',
                                    height: '100px',
                                    cursor: 'pointer',
                                    backgroundColor: selectedIndex === index ? '#e6f2ff' : '#f9f9f9',
                                    border: selectedIndex === index ? '2px solid #0d6efd' : '1px solid #ddd',
                                    transition: 'all 0.2s ease-in-out',
                                }}
                                onClick={() => setSelectedIndex(index)}
                            >
                                <div className="fw-bold text-dark">
                                    {dateObj.format('MM/DD/YY')}
                                </div>
                                <div className="text-muted fs-12">
                                    {dateObj.format('dddd')}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    size="sm"
                    className="ms-auto"
                    onClick={printPage}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <Spinner
                                size="sm"
                                animation="border"
                                className="me-2"
                            />
                            loading...
                        </>
                    ) : (
                        "Print"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>

    )
}

export default CycleDatesModal